module.exports = __webpack_public_path__ + "img/Oxazepam (BZO).f07116e6.png";